import { Outlet } from 'react-router-dom';

import { usePermissions } from '~src/main/hooks/usePermissions';
import { TransportRole } from '~src/main/providers/PermissionProvider';
import { AppUnauthorized } from '~src/pages/app/app-unauthorized';

export function RouteWithRole({ roles }: { roles: TransportRole[] }) {
  const { hasRole } = usePermissions();

  return hasRole(roles) ? <Outlet /> : <AppUnauthorized />;
}
